import { SnackbarFunctionProps } from '@lyearn/ui';
import {
  DatabaseFormEditorAction,
  DatabseFormEditorErrors,
} from '@/modules/corporate/modules/database/views/FormView/components/DatabaseFormEditor/types';
import {
  DatabaseFieldTypeEnum,
  DatabaseMetadataFieldType,
  DatabaseViewFieldType,
  PublishContentConfig,
  UpdateSurveyInput,
} from '@/types/schema';

export enum SurveyEditorActionEnum {
  AddField = 'ADD_FIELD',
  UpdateSurvey = 'UPDATE_SURVEY',
  ExecuteUpdateSurvey = 'EXECUTE_UPDATE_SURVEY',
  PublishSurvey = 'PUBLISH_SURVEY',
  PublishDialog = 'PUBLISH_DIALOG',
}

export interface SurveyDatabaseFieldsState {
  metadataFields: DatabaseMetadataFieldType[];
  viewFields: DatabaseViewFieldType[];
}

interface AddFieldAction {
  type: SurveyEditorActionEnum.AddField;
  payload: { type: DatabaseFieldTypeEnum };
}

interface UpdateSurveyAction {
  type: SurveyEditorActionEnum.UpdateSurvey | SurveyEditorActionEnum.ExecuteUpdateSurvey;
  payload: { updates: Partial<UpdateSurveyInput>; snackbarProps?: SnackbarFunctionProps };
}

interface PublishSurveyAction {
  type: SurveyEditorActionEnum.PublishSurvey;
  payload: { publishConfig?: PublishContentConfig; snackbarProps?: SnackbarFunctionProps };
}

interface PublishDialogAction {
  type: SurveyEditorActionEnum.PublishDialog;
}

export type SurveyEditorActions =
  | AddFieldAction
  | UpdateSurveyAction
  | PublishSurveyAction
  | PublishDialogAction;

export interface SurveyEditorUIState {
  selectedBlockId: string | null;
  errors: DatabseFormEditorErrors;
  isOfSameWorkspace: boolean;
  showPublishChangesDialog: boolean;
  isPublishing?: boolean;
}

export type onSurveyEditorAction = (action: SurveyEditorActions | DatabaseFormEditorAction) => void;
